import { call, put, takeEvery } from "redux-saga/effects"

import { GET_INVOICES } from "./actionTypes"

import { getInvoicesSuccess, getInvoicesError } from "./actions"

import { genericGetRequest } from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

function* onGetInvoices(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let endpoint = '/api/v1/invoices'
    if (action.payload.use_bill_com) {
      endpoint = '/api/v1/bill_com_invoices'
    }
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {}, // no query parameters
      {
        Authorization: user.token,
        "account-id": user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id,
      }
    )
    yield put(getInvoicesSuccess(response))
  } catch (error) {
    yield put(getInvoicesError(error))
  }
}

function* InvoicesSaga() {
  yield takeEvery(GET_INVOICES, onGetInvoices)
}

export default InvoicesSaga
